export const environment = {
  isReleaseBuild: false,
  envName: 'Project Four Angular 17 TEST',
  isDev: true,
  enableDebug: false,
  useCache: false,
  useProxy: true,
  baseApiUrl: '/Services/Messenger/',
  host: 'https://mpluswsmo.energytransfer.com',
  port: ':80',
  secondaryUrl: 'https://mpluswsmo.energytransfer.com',
  infoPostBaseUrl: 'http://mo.peplmessenger.energytransfer.com/mo/ipost',
  extSecurityUrl: 'https://mo.security.energytransfer.net/',
  disableBackFilling: true,
  msal: {
    clientId: '4b4f2d99-6c76-48a7-aa25-f6def879833a',
    authority: 'https://login.microsoftonline.com/28fbb2af-a743-4fb9-8e66-24d90147e2ec',
    redirectUri: 'https://projfour.messenger.energytransfer.com',
    scope: '4b4f2d99-6c76-48a7-aa25-f6def879833a/access_as_user',
    protectedResourceURL: 'https://mpluswsmo.energytransfer.com/Services/Messenger'
  }

  // Temporarily replacing this config with ProjOne to test Angular 17 upgrade while including assets from the TGR assets that aren't across all environments yet.
  // Below is the original ProjFour config that will be switched back once testing is complete and assets are aligned across environments.
  /* baseApiUrl: '/Services/Messenger/',
  host: 'https://webservicesmo.energytransfer.com',
  port: ':443',
  secondaryUrl: 'https://webservicesmo.energytransfer.com',
  infoPostBaseUrl: 'http://mo.peplmessenger.energytransfer.com/mo/ipost',
  extSecurityUrl: 'https://mo.security.energytransfer.net/',
  msal: {
    clientId: '4b4f2d99-6c76-48a7-aa25-f6def879833a',
    authority: 'https://login.microsoftonline.com/28fbb2af-a743-4fb9-8e66-24d90147e2ec',
    redirectUri: 'https://projfour.messenger.energytransfer.com',
    scope: '4b4f2d99-6c76-48a7-aa25-f6def879833a/access_as_user',
    protectedResourceURL: 'https://mpluswsmo.energytransfer.com/Services/Messenger'
  } */
};
